import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from '@reporting/app.component';
import { appConfig } from '@reporting/app.config';

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
